import { Component, OnInit, Input } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { Urls } from '../../../../utils/catalogue/urls';
import { ApiService } from '../../../../shared/catalogue/services/api.service';
import { CommonDataService } from '../../../../shared/catalogue/services/common-data.service';
import { DATA_PER_PAGE, Setion_deleted, CANCEL, Something_went_wrong } from './../../../../app.constant';

@Component({
  selector: 'app-add-section',
  templateUrl: './add-section.component.html',
  styleUrls: ['./add-section.component.scss'],
})
export class AddSectionComponent implements OnInit {
  userData: any = {};
  @Input() typeList = [];
  @Input() selectedTab : string;
  sectionList = [];
  pageSize: number = DATA_PER_PAGE;

  constructor(
    public apiService: ApiService,
    private toastr: ToastrService,
    public commonDataService: CommonDataService
  ) {}

  ngOnInit() {
    // this.getTypes();
    this.getSections();

  }

  getTypes = () => {
    this.apiService.getData(Urls.getTypes).subscribe((response: any) => {
      this.typeList = response.data.types;
      const typeList = response.data.types || [];
      this.typeList = typeList.filter(
        (i) => i.id === 3 || i.id === 4 || i.id === 2 || i.id === 7
      );
    });
    this.getSections();
  };

  getSections = () => {
    let obj;
    this.apiService.getData(Urls.getSections).subscribe((response: any) => {
      obj = response.data.subTypes;
      if(this.selectedTab === 'Investors'){
        this.sectionList = obj.filter((obj) => {
          return obj.type === 'Forms' || obj.type === 'Process' || obj.type === 'SEBI Circulars-Scores Portal';
        });
      }else if(this.selectedTab === 'Partners'){
        this.sectionList = obj.filter((obj) => {
          return obj.type === 'Forms and Marketing Colletarals ' || obj.type === 'Disclosure';
        });
      }else if(this.selectedTab === 'Downloads'){
        this.sectionList = obj.filter((obj) => {
          return obj.type === 'Downloads';
        });
      }
    });
    
    
  };

  editData = (id) => {
    const index = this.sectionList.findIndex((x) => x.id === id);
    const editData = this.sectionList[index];
    this.userData.id = editData.id;
    this.userData.typeId = editData.typeId;
    this.userData.section = editData.sections;
    this.scrollTop();
  };

  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  };

  deleteData = (id) => {
    this.commonDataService
      .confirm('Are you sure want to delete?', 'md')
      .then((confirmed) => {
        if (confirmed) {
          this.apiService
            .postData(Urls.deleteSection, { id })
            .subscribe((response: any) => {
              this.toastr.success(Setion_deleted);
              this.getSections();
            });
        }
      })
      .catch(() => {
        this.toastr.error(CANCEL);
      });
  };

  proceesData = (formVal) => {
    let url;
    let msg;
    if (this.userData.id) {
      url = Urls.editSection;
      msg = 'Section Updated';
    } else {
      url = Urls.addSection;
      msg = 'Section Added';
    }
    this.apiService.postData(url, this.userData).subscribe((response: any) => {
      if (response.status === 0) {
        this.toastr.success(msg);
        formVal.resetForm();
        this.getSections();
      } else {
        this.toastr.error(Something_went_wrong);
      }
    });
  };
}
